module.exports = __webpack_public_path__ + "static/media/Xeirokrotima_2.09c2f696.jpg";